import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import { BehaviorSubject, Observable } from 'rxjs';

import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import * as backInter from 'app/auth/auth-data.model';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'traducciones',
  templateUrl: './traducciones.component.html',
  styleUrls: ['./traducciones.component.scss']
})
export class TraduccionesComponent implements OnInit {

  // firstFormGroup: FormGroup;
  // secondFormGroup: FormGroup;
  @Input('pasoCompleto') pasoCompleto?: boolean;
  @Input('productoCertificar') productoCertificar: backInter.prodCert;
  @Input('idiomas') idiomas: backInter.getIdiomas;
  @Input('preguntasAdicionales') preguntasAdicionales: backInter.getAdicionales;

  private eventsSubscription: any
  @Input() actualizaAdicionales: Observable<any>;

  @Output() actualizarAdicionales: EventEmitter<boolean> = new EventEmitter();

  idiomaDefault: backInter.getIdiomaInd;
  idiomasAdicionales: backInter.getIdiomaInd[] = [];

  textosPreguntasFiltrados: any[] = [];
  nombreIdiomaAdicional: any[] = [];
  textosPreguntasRestoIdiomas: any[] = [];

  formGroups: FormGroup[] = [];

  totalTextosTraduccion = 0;
  numeroTextosTraduccion: number[] = [];

  idsTraduccionesBD: any[] = [];
  idsTraduccionesOpcionesBD: any[] = [];

  //tipos de pregunta
  idAbierta = 2;
  idSingle = 1;
  idMulti = 6;

  //etiquetas para encontrar los textos de traduccion
  mensajesTraducirKeys: string[] = [
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_ERR',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_MOD_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.PREG_MOD_ERR',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_NOPREG',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_ERR',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_MOD_OK',
    'CERTIFICAR.ADICIONALES.TRADUCCIONES.MENSAJES.OPC_MOD_ERR'
  ]
  //variables que tomaran las traducciones indicadas en la variable anterior
  //deben ir en el mismo orden
  mensajesTraducirTS = {
    preg_ok: '',
    preg_err: '',
    preg_mod_ok: '',
    preg_mod_err: '',
    opc_nopreg: '',
    opc_ok: '',
    opc_err: '',
    opc_mod_ok: '',
    opc_mod_err: ''
  };

  constructor(
    private _formBuilder: FormBuilder,
    private adicionalesService: AdicionalesService,
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
  }

  ngOnInit() {
    this.eventsSubscription = this.actualizaAdicionales.subscribe( (datos) => {
      console.log("actualiza lista adicionales en traducciones");
      this.reiniciaVariables();
      this.preguntasAdicionales = datos;
      this.obtieneIdiomas();
    })
    setTimeout( () => {
      this.obtieneIdiomas();
      this.traduceTextosTS();
      // console.log(this.preguntasAdicionales);
    },2000);
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
  }

  reiniciaVariables(){
    this.idiomaDefault = null;
    this.idiomasAdicionales = [];
    this.textosPreguntasFiltrados = [];
    this.nombreIdiomaAdicional = [];
    this.textosPreguntasRestoIdiomas = [];
    this.formGroups = [];
    this.totalTextosTraduccion = 0;
    this.numeroTextosTraduccion = [];
    this.idsTraduccionesBD = [];
  }

  obtieneIdiomas(){
    if(this.idiomas.idiomasMostrar.length > 0){

      console.log("tamaño idiomas");
      console.log(this.idiomas.idiomasMostrar.length);
      this.idiomas.idiomasMostrar.forEach( (idioma: backInter.getIdiomaInd) => {
        if(idioma.tipoIdioma == "1"){
          this.idiomaDefault = idioma;
        }
        else if(idioma.tipoIdioma == "0"){
          this.idiomasAdicionales.push(idioma);
        }
      });
      console.log(this.idiomaDefault);
      this.filtraTextosIdiomaPrincipal();
      this.creaFormGroups();
    }
  }

  creaFormGroups(){
    console.log(this.numeroTextosTraduccion);
    for(let i=0;i<this.idiomasAdicionales.length;i++){
      // this.formGroups.push(new FormGroup({}) );
      let group = {};

      let iterador = 0;
      this.numeroTextosTraduccion.forEach( (objeto) => {

        group["texto"+iterador] = new FormControl('');
        if(objeto > 1){
          for(let x=0;x<objeto-1;x++){
            console.log("texto"+iterador+"Opc"+x);
            group["texto"+iterador+"Opc"+x] = new FormControl('');
          }
        }

        iterador++;
      });

      // for(let j=1;j<=5;j++){
      //   group['control'+j] = new FormControl('');
      // }
      this.formGroups.push(new FormGroup(group) );
    }
  }

  filtraTextosIdiomaPrincipal(){
    this.preguntasAdicionales.adicionalesMostrar.forEach( (adicional) => {
      adicional.adicional.forEach( (textos) => {
        if(textos.idiomaAdicionales == this.idiomaDefault._id){

          let objetoTextoAdicional = {};
          let numeroTextos = 0;
          if(textos.tipoPreguntaAdicionales == this.idAbierta){
            objetoTextoAdicional = {
              textoPregunta : textos.textoPregunta,
              tipoPregunta : textos.tipoPreguntaAdicionales,
              idAdicional : adicional._id,
              orden: adicional.orden
            };
            numeroTextos++;
            this.totalTextosTraduccion++;
          }
          else if(textos.tipoPreguntaAdicionales == this.idSingle || textos.tipoPreguntaAdicionales == this.idMulti){
            let textosOpciones: any[] = [];
            textos.opciones.forEach( (txtOpcion) => {
              textosOpciones.push({textoOpcion: txtOpcion.textoOpcion, ordenOpcion: txtOpcion.ordenOpcion});
              numeroTextos++;
              this.totalTextosTraduccion++;
            });
            objetoTextoAdicional = {
              textoPregunta : textos.textoPregunta,
              tipoPregunta : textos.tipoPreguntaAdicionales,
              opcionesResp : textosOpciones,
              idAdicional : adicional._id,
              orden: adicional.orden
            };
            numeroTextos++;
            this.totalTextosTraduccion++;
          }

          this.textosPreguntasFiltrados.push(objetoTextoAdicional);
          this.numeroTextosTraduccion.push(numeroTextos);
        }
        else {

          let posTextosTraduc = 0;

          if(this.nombreIdiomaAdicional.indexOf(textos.idiomaAdicionales) != -1){
            posTextosTraduc = this.nombreIdiomaAdicional.indexOf(textos.idiomaAdicionales);
          }
          else{
            this.nombreIdiomaAdicional.push(textos.idiomaAdicionales);
            console.log(this.nombreIdiomaAdicional);
            let traduccion: any[] = [];
            this.textosPreguntasRestoIdiomas.push(traduccion);
            posTextosTraduc = this.nombreIdiomaAdicional.indexOf(textos.idiomaAdicionales);
          }

          // console.log("-----------------inicia ciclo de idioma---------------");
          // // console.log("adicionales idioma "+textos.idiomaAdicionales);
          // console.log("adicionales idioma ");
          // console.log(textos);

          let objetoTextoAdicional: any;

          if(textos.tipoPreguntaAdicionales == this.idAbierta){

            objetoTextoAdicional = {
              textoPregunta : textos.textoPregunta,
              tipoPregunta : textos.tipoPreguntaAdicionales,
              idAdicional : adicional._id,
              orden: adicional.orden,
              idAdicionalInterna: textos._id
            };

          }
          else if(textos.tipoPreguntaAdicionales == this.idSingle || textos.tipoPreguntaAdicionales == this.idMulti){

            let textosOpciones: any[] = [];
            let textosOpcionesRelleno: any[] = [];

            textos.opciones.forEach( (txtOpcion) => {
              textosOpciones.push({textoOpcion: txtOpcion.textoOpcion, ordenOpcion: txtOpcion.ordenOpcion, idAdicionalOpcion:txtOpcion._id});
              this.totalTextosTraduccion++;
            });

            //ordena las opciones segun el numero de orden que traen
            textosOpciones.sort( (a,b) => {
              if(a.ordenOpcion > b.ordenOpcion){
                return 1;
              } else{
                return -1;
              }
            });

            //llena el espacio vacio entre opciones recuperadas
            for(let i=0;i<textosOpciones.length;i++){

              if(textosOpcionesRelleno.length == 0){
                if(textosOpciones[i].ordenOpcion > 0){
                  for(let it=0;it<textosOpciones[i].ordenOpcion;it++){

                    let objetoVacioParaLlenar = {
                      textoOpcion: null,
                      ordenOpcion: it
                    };

                    textosOpcionesRelleno.push(objetoVacioParaLlenar);

                  }
                }
              }
              else{
                let tamArreglo = textosOpcionesRelleno.length;
                let ordenAnterior = textosOpcionesRelleno[tamArreglo-1].ordenOpcion;
                if(textosOpciones[i].ordenOpcion != ordenAnterior+1){
                  // console.log("el orden "+objetoTextoAdicional.orden+" no es inmediato al orden "+ordenAnterior);
                  for(let it=ordenAnterior+1;it<textosOpciones[i].ordenOpcion;it++){

                    let objetoVacioParaLlenar = {
                      textoOpcion: null,
                      ordenOpcion: it
                    };
                    textosOpcionesRelleno.push(objetoVacioParaLlenar);
                  }
                }
              }

              textosOpcionesRelleno.push(textosOpciones[i]);

            }

            // console.log("objeto de opciones original:");
            // console.log(textosOpciones);
            // console.log("objeto de opciones con relleno:");
            // console.log(textosOpcionesRelleno);

            objetoTextoAdicional = {
              textoPregunta : textos.textoPregunta,
              tipoPregunta : textos.tipoPreguntaAdicionales,
              // opcionesResp : textosOpciones,
              opcionesResp : textosOpcionesRelleno,
              idAdicional : adicional._id,
              orden: adicional.orden,
              idAdicionalInterna: textos._id
            };

          }

          if(this.textosPreguntasRestoIdiomas[posTextosTraduc].length == 0){
            // console.log("entro al caso arreglo textos idioma = 0 - "+adicional._id);
            if(objetoTextoAdicional.orden > 0){
              // console.log("el valor de orden es "+objetoTextoAdicional.orden)
              for(let it=0;it<objetoTextoAdicional.orden;it++){

                let objetoVacioParaLlenar = {};
                let opcionesVacio: any[] = [];
                objetoVacioParaLlenar = {
                  textoPregunta : null,
                  tipoPregunta : null,
                  opcionesResp : opcionesVacio,
                  idAdicional : null,
                  orden: it
                };
                // console.log("objeto a añadir al arreglo:");
                // console.log(objetoVacioParaLlenar);
                this.textosPreguntasRestoIdiomas[posTextosTraduc].push(objetoVacioParaLlenar);

              }
            }
          }
          else{
            let tamArreglo = this.textosPreguntasRestoIdiomas[posTextosTraduc].length;
            let ordenAnterior = this.textosPreguntasRestoIdiomas[posTextosTraduc][tamArreglo-1].orden;
            if(objetoTextoAdicional.orden != ordenAnterior+1){
              // console.log("el orden "+objetoTextoAdicional.orden+" no es inmediato al orden "+ordenAnterior);
              for(let it=ordenAnterior+1;it<objetoTextoAdicional.orden;it++){

                let objetoVacioParaLlenar = {};
                let opcionesVacio: any[] = [];
                objetoVacioParaLlenar = {
                  textoPregunta : null,
                  tipoPregunta : null,
                  opcionesResp : opcionesVacio,
                  idAdicional : null,
                  orden: it
                };
                this.textosPreguntasRestoIdiomas[posTextosTraduc].push(objetoVacioParaLlenar);
              }
            }
          }


          // this.textosPreguntasFiltrados.push(objetoTextoAdicional);
          // console.log("textos del idioma:");
          // console.log(objetoTextoAdicional);
          // console.log("-----------------finaliza ciclo de idioma---------------");

          this.textosPreguntasRestoIdiomas[posTextosTraduc].push(objetoTextoAdicional);
          // this.textosPreguntasRestoIdiomas[posTextosTraduc][objetoTextoAdicional.orden] = objetoTextoAdicional;
        }
      });
    });

    // console.log("nombres idiomas adicionales:");
    // console.log(this.nombreIdiomaAdicional);
    console.log("Textos idioma nativo:");
    console.log(this.textosPreguntasFiltrados);
    console.log("Textos traducciones:");
    console.log(this.textosPreguntasRestoIdiomas);
    // console.log(this.numeroTextosTraduccion);
    // console.log("total textos:"+this.totalTextosTraduccion);
  }

  guardaTraduccion(event:any, datos:any, idIdioma:string, identificador:string, idAdicional?:string){
    // console.log(this.productoCertificar.fechaCertificar);
    // console.log(event.target.value);
    // console.log(datos);
    if(event.target.value.length > 0){
      let index = 0;
      let idTraduccionEncontrado:string;
      var BreakException = {};
      try {
          this.idsTraduccionesBD.forEach( (elemento) => {
            if(elemento.identificador == identificador && elemento.idIdioma == idIdioma){
              idTraduccionEncontrado = elemento.idTraduccion;
              throw BreakException;
            }
            index++;
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      }
      if(idAdicional){
        this.modificaTraduccionBD(event, datos, idAdicional);
      }
      else{
        if(idTraduccionEncontrado){
          //actualiza la traduccion con la id encontrada
          this.modificaTraduccionBD(event, datos, idTraduccionEncontrado);
        }
        else{
          //guarda la nueva traduccion
          this.guardaTraduccionBD(event, datos, idIdioma, identificador);
        }
      }
    }
  }

  guardaTraduccionBD(event:any, datos:any, idIdioma:string, identificador:string){
    let traduccion = {} as backInter.nuevoAdicional;
    traduccion.adicionalId = datos.idAdicional;
    traduccion.fechaCertificar = this.productoCertificar.fechaCertificar;
    traduccion.tipoPreguntaAdicionales = datos.tipoPregunta;
    traduccion.textoPregunta = event.target.value;
    traduccion.idiomaAdicionales = idIdioma;
    traduccion.orden = datos.orden;

    console.log("identificador:"+identificador);
    console.log("traduccion a guardar:");
    console.log(traduccion);

    this.adicionalesService.guardaTraduccionAdicional(traduccion).subscribe( (data: backInter.respuestaTraduccionAdicional) => {
      if(data.message == "Success: New lang registered"){
        this.idsTraduccionesBD.push({idTraduccion:data.idInterna, identificador:identificador, idIdioma:idIdioma});
        this.openSnackBar(this.mensajesTraducirTS.preg_ok, "OK");
        this.actualizarAdicionales.emit(true);
      }
      else this.openSnackBar(this.mensajesTraducirTS.preg_err, "OK");
    });
  }

  modificaTraduccionBD(event:any, datos:any, idTraduccion:string){
    let traduccion = {} as backInter.modificaAdicional;
    traduccion.fechaCertificar = this.productoCertificar.fechaCertificar;
    traduccion.arrayId = datos.idAdicional;
    traduccion.adicionalId = idTraduccion;
    traduccion.textoPregunta = event.target.value;

    console.log("actualizar");
    console.log(traduccion);

    this.adicionalesService.actualizaAdicional(traduccion).subscribe( (data: backInter.respuestaModifAdicional) => {
      if(data.message == "Success"){
        this.openSnackBar(this.mensajesTraducirTS.preg_mod_ok, "OK");
        this.actualizarAdicionales.emit(true);
      }
      else this.openSnackBar(this.mensajesTraducirTS.preg_mod_err, "OK");
      // console.log(data);
    });
  }

  guardaTraduccionOpcion(event:any, datos:any, idIdioma:string, idPreg:number, idOpc:number, datosOpc:any, idOpcionAdicional?:string, idAdicional?:string){
    // console.log(this.productoCertificar.fechaCertificar);
    // console.log(event.target.value);
    // console.log(datos);
    console.log(this.idsTraduccionesBD);
    // console.log(datosOpc);
    if(event.target.value.length > 0){
      let index = 0;
      let idTraduccionEncontrado:string;
      var BreakException = {};
      try {
          this.idsTraduccionesBD.forEach( (elemento) => {
            if(elemento.identificador == 'texto'+idPreg && elemento.idIdioma == idIdioma){
              idTraduccionEncontrado = elemento.idTraduccion;
              throw BreakException;
            }
            index++;
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      }

      if(idAdicional){
        idTraduccionEncontrado = idAdicional;
      }

      if(idTraduccionEncontrado){

        let idTraduccionOpcionEncontrado:string;
        let BreakException = {};
        try {
            this.idsTraduccionesOpcionesBD.forEach( (opcion) => {
              if(opcion.identificador == 'texto'+idPreg+'Opc'+idOpc && opcion.idIdioma == idIdioma){
                idTraduccionOpcionEncontrado = opcion.idTraduccion;
                throw BreakException;
              }
            });
        } catch (e) {
            if (e !== BreakException) throw e;
        }

        if(idOpcionAdicional){
          idTraduccionOpcionEncontrado = idOpcionAdicional;
        }
        if(idTraduccionOpcionEncontrado){
          // this.openSnackBar("actualizar texto", "OK");
          // console.log("actualizar traduccion opcion");
          this.actualizaTraduccionOpcionBD(event, datos, idTraduccionEncontrado, idTraduccionOpcionEncontrado);
        }
        else{
          // console.log("guardar traduccion opcion");
          this.guardaTraduccionOpcionBD(event, datos, idTraduccionEncontrado, idIdioma, 'texto'+idPreg+'Opc'+idOpc, datosOpc.ordenOpcion );
        }


      }
      else{
        // no puede guardar texto traduccion, primero debe guardar texto de pregunta
        this.openSnackBar(this.mensajesTraducirTS.opc_nopreg, "OK");
      }
    }
  }

  guardaTraduccionOpcionBD(event:any, datos:any, idTraduccion:string, idIdioma:string, identificador:string, orden:string){
    let traduccion = {} as backInter.nuevaOpcionAdicional ;
    traduccion.fechaCertificar = this.productoCertificar.fechaCertificar;
    traduccion.arrayId = datos.idAdicional;
    traduccion.adicionalId = idTraduccion;
    traduccion.textoOpcion = event.target.value;
    traduccion.ordenOpcion = orden;

    // console.log("identificador:"+identificador);
    // console.log("traduccion de opcion a guardar:");
    // console.log(traduccion);

    this.adicionalesService.guardaOpcionRespuestaAdicional(traduccion).subscribe( (data: backInter.respuestaNuevaOpcionAdicional) => {
      if(data.message == "Success"){
        this.idsTraduccionesOpcionesBD.push({idTraduccion:data.opcionMostrar._id, identificador:identificador, idIdioma:idIdioma});
        this.openSnackBar(this.mensajesTraducirTS.opc_ok, "OK");
        this.actualizarAdicionales.emit(true);
      }
      else this.openSnackBar(this.mensajesTraducirTS.opc_err, "OK");
    });
  }

  actualizaTraduccionOpcionBD(event:any, datos:any, idTraduccion:string, idOpcionEncontrado:string){
    let opcion = {} as backInter.nuevaOpcionAdicional;
    opcion.fechaCertificar = this.productoCertificar.fechaCertificar;
    opcion.arrayId = datos.idAdicional;
    opcion.adicionalId = idTraduccion;
    opcion.idOpcion = idOpcionEncontrado;
    opcion.textoOpcion = event.target.value;

    console.log("se actualizara una opcion. datos:");
    console.log(opcion);

    this.adicionalesService.actualizaOpcionRespuestaAdicional(opcion)
    .subscribe( (data: backInter.respuestaModificaOpcionAdicional) => {
      if(data.message == "Success"){
        // this.enviaMensajeSnack(9);
        // console.log("se actualizo la opcion");
        this.openSnackBar(this.mensajesTraducirTS.opc_mod_ok, "OK");
        this.actualizarAdicionales.emit(true);
      }
      else
        this.openSnackBar(this.mensajesTraducirTS.opc_mod_err, "OK");
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

}
